import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import { ButtonSkeleton, Skeleton } from "@internal/ui"
import { BookingBreadcrumbs } from "../Breadcrumbs"

export function LoadingPage({ onReturnToProviderResults }: { onReturnToProviderResults?: () => void }) {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        inlineSize: "100%",
        gap: theme.spacing(theme.tokens.spacing.lg),
        maxInlineSize: 640,
        blockSize: "100%"
      })}
    >
      <BookingBreadcrumbs onReturnToSearchResults={onReturnToProviderResults} />
      <Box
        role="status"
        aria-label="Loading"
        aria-busy="true"
        sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.lg) })}
      >
        <Box
          sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.sm) })}
        >
          <Skeleton width="60%" height={32} />
          <Skeleton width="100%" height={16} />
          <Skeleton width="85%" height={16} />
        </Box>

        <Box
          sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.md) })}
        >
          <Skeleton width="40%" height={24} />
          <Skeleton width="100%" height={240} sx={(theme) => ({ borderRadius: theme.tokens.borderRadius.md })} />
          <Skeleton
            width="70%"
            height={24}
            sx={(theme) => ({ marginBlockStart: theme.spacing(theme.tokens.spacing.sm) })}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <ButtonSkeleton width={144} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
